export default "__VITE_ASSET__BA4K8vZf__"